<footer class="footer">
  <div class="footer-content">
    <p class="copyright">© {{ currentYear }} {{ 'footer.title' | translate }}</p>
    <p class="ministry">{{ 'footer.description' | translate }}</p>
  </div>
</footer>
